import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { ListItemText } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Arbitrator from './Arbitrator';
import axios from 'axios';

const styles = theme => ({
    root: {
        display: 'flex',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        margin: theme.spacing.unit * 3,
    },
});

class ArbitrationList extends Component {
    state = {
      value: null,
      open: false,
      uniqueId: localStorage.getItem('token'),
    };
    
    componentDidMount(){
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getCaseInfo`;
        let payload = {
            caseId: this.props.match.params.id,
        }
        axios.post(url, payload)
        .then((response) => {
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            this.setState({value: response.data.claimantArbitrator});

        })
        .catch((error) => {
            console.log(error);
        });

        this.props.getArbitrators(localStorage.getItem('token'));
    }

    handleChange = event => {
        this.setState({
            value: event.target.value,
             open: true,
        });
        //this.props.setArbitrators(this.props.match.params.id, event.target.value, this.props.handleComplete);
    }

    setArbitrators = () => {
        console.log('setArbitrators1')
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        // if(this.props.caseData.claimantUniqueId == this.state.uniqueId){
        //     userType = 'claimant';
        // }
        // else if(this.props.caseData.respondentUniqueId == this.state.uniqueId){
        //     userType = 'respondent';
        // }

        this.props.setArbitrators(this.props.match.params.id, false, this.state.value, userType, this.props.handleComplete);
    }


    toggleOpen = () => {
        this.setState((prevState) => ({
            open: !prevState.open,
        }));
      }

    render(){
        const { classes, isLoading, arbitrators } = this.props;
        var lang = localStorage.getItem('language');
        if(isLoading){
            return(
                <CircularProgress size={50} thickness={3} className={classes.progress}/>
            );
        }

        return(
            <div className={classes.root}>
                <FormControl component='fieldset' className={classes.formControl}>
                    <RadioGroup
                        name='chooseArbitrator'
                        className={classes.group}
                        value={this.state.value}
                        onChange={this.handleChange}
                    >
                            {
                                // <form >
                                // <input type="radio" name="paymentMethod" value="visa" />VISA <br></br><br></br>
                                
                                arbitrators.map((arbitrator, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={arbitrator.arbitratorId}
                                        label={<Arbitrator 
                                                    firstName={arbitrator.firstname}
                                                    lastName={arbitrator.lastname}
                                                    occupation={arbitrator.occupation}
                                                    jurisdiction={arbitrator.jurisdiction}
                                                    expertise={arbitrator.expertise}
                                                    lang = {lang}
                                                    arbitratorId={arbitrator.arbitratorId}
                                                    arbitrator={this.context.t('arbitrator')}
                                                    arbitratorProfile={this.context.t('arbitratorProfile')}
                                                    jurisdictions={ this.context.t('Jurisdiction') }
                                                    occupations={ this.context.t('Occupation') }
                                                    firstName_chi={arbitrator.firstname_chi}
                                                    lastName_chi={arbitrator.lastname_chi}
                                                    occupation_chi={arbitrator.occupation_chi}
                                                    jurisdiction_chi={arbitrator.jurisdiction_chi}
                                                    expertise_chi={arbitrator.expertise_chi}
                                                />}
                                                    control={<Radio key={index }
                                                    classes={{root: classes.radio, checked: classes.checked}}
                                                    disabled
                                                />}
                                    />
                                ))
                                // </form>
                            }
                    </RadioGroup>
                </FormControl>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.arbitrator.loading,
        arbitrators: state.arbitrator.arbitrators,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        caseData: state.caseInfo.caseData
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getArbitrators: () => dispatch(actions.arbitrators()),
        setArbitrators: (caseId, firstTime, arbitratorId, type, handleComplete) => dispatch(actions.setArbitrators(caseId, firstTime, arbitratorId, type, handleComplete)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ArbitrationList)));
